import { type FC, type PropsWithChildren } from 'react';
import { Header, Island, Link, Text, VStack } from '@direct-frontend/components';
import { YANDEX_KIT_BRAND_NAME } from '#shared/lib/const';
import { addonsRoute } from '#shared/lib/routes';

type WrapperProps = PropsWithChildren<{}>;

const urlAddons = addonsRoute.getUrl();

const LINK_MORE_DETAILS = 'https://yandex.ru/support/kit/ru/store-control/services/';

export const Wrapper: FC<WrapperProps> = ({ children }) => (
    <Island>
        <VStack gap="28">
            <VStack gap="8">
                <Header
                    level="h2"
                    caption={
                        <>
                            Услуги оплачиваются покупателями отдельно, не на сайте {YANDEX_KIT_BRAND_NAME}. Вам
                            необходимо направить покупателям ссылки на оплату услуг самостоятельно.{' '}
                            <Link href={LINK_MORE_DETAILS} target="_blank" rel="noreferrer">
                                Подробнее
                            </Link>
                        </>
                    }
                >
                    Услуги
                </Header>
                <Text color="gray" role="supplementary">
                    Добавить и отредактировать услуги можно в разделе <Link href={urlAddons}>Услуги</Link>.
                </Text>
            </VStack>
            {children}
        </VStack>
    </Island>
);
